(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
function setupFooter(){const mobile=matchMedia('(max-width:540px)');document.querySelectorAll('.aw-footer').forEach(footer=>{if(footer.dataset.ready)return;footer.dataset.ready='true';const groups=footer.querySelectorAll('.aw-footer-group');function sync(){groups.forEach(g=>{g.open=!mobile.matches||!!g.querySelector('.errors,[role="status"]');g.querySelector('summary').tabIndex=mobile.matches?0:-1})}groups.forEach(g=>g.querySelector('summary').addEventListener('click',e=>{if(!mobile.matches)e.preventDefault()}));sync();mobile.addEventListener('change',sync)})}setupFooter();document.addEventListener('shopify:section:load',setupFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veridz-review-cards"] && !Shopify.designMode) return;
  try {
    
function initVeridzReviewCards(root) {
  root.querySelectorAll('[data-review-cards]').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const track = section.querySelector('.veridz-card-track');
    const pager = section.querySelector('.veridz-review-pages');
    const cards = Array.from(track.children);
    let positions = [];
    function update() {
      let active = 0;
      positions.forEach((position, i) => { if (Math.abs(position - track.scrollLeft) < Math.abs(positions[active] - track.scrollLeft)) active = i; });
      Array.from(pager.children).forEach((button, i) => button.setAttribute('aria-current', String(i === active)));
    }
    function layout() {
      if (!cards.length) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const stride = cards[0].getBoundingClientRect().width + gap;
      const visible = Math.max(1, Math.floor((track.clientWidth + gap + 1) / stride));
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      positions = [];
      for (let i = 0; i < cards.length; i += visible) {
        const position = Math.min(i * stride, max);
        if (!positions.includes(position)) positions.push(position);
      }
      pager.replaceChildren();
      if (positions.length > 1) positions.forEach((position, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', pager.dataset.pageLabel.replace('[number]', String(i + 1)));
        button.addEventListener('click', () => track.scrollTo({left: position, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}));
        pager.append(button);
      });
      update();
    }
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(layout).observe(track);
    layout();
  });
}
initVeridzReviewCards(document);
document.addEventListener('shopify:section:load', event => initVeridzReviewCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veridz-reviews"] && !Shopify.designMode) return;
  try {
    
function initializeVeridzReviews(root) {
  root.querySelectorAll('[data-veridz-reviews]').forEach(carousel => {
    if (carousel.dataset.initialized) return;
    carousel.dataset.initialized = 'true';
    const track = carousel.querySelector('.veridz-review-track');
    carousel.querySelectorAll('[data-review-direction]').forEach(button => {
      button.addEventListener('click', () => {
        const card = track.querySelector('.veridz-review-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({left: (card.getBoundingClientRect().width + gap) * Number(button.dataset.reviewDirection), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    });
  });
}
initializeVeridzReviews(document);
document.addEventListener('shopify:section:load', event => initializeVeridzReviews(event.target));

  } catch(e) { console.error(e); }
})();
})();
